import React from "react";
import { Tabs } from "@opendate-app/setlist";

import ErrorsContainer from "../../BeefreeTemplates/ErrorsContainer";
import { useActionContext } from "./ActionContainer";
import ActionDropdown from "./ActionDropdown";

const ActionTabHeader = () => {
  const {
    tab,
    setTab,
    isEmailTemplate,
  } = useActionContext();

  const items = [
    { value: "content", label: "Content" },
    ...(isEmailTemplate ? [{ value: "preview", label: "Preview" }] : []),
  ];

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: 12, marginBottom: 12 }}>
      <Tabs items={items} value={tab} onChange={setTab} collapseBelow={0} />
      <div className="d-flex align-items-center" style={{ gap: 12 }}>
        <ErrorsContainer templatableContext={useActionContext} />
        <ActionDropdown />
      </div>
    </div>
  );
};

export default ActionTabHeader;
